module.exports = __webpack_public_path__ + "img/st.973af64b.svg";